import { useEffect, useState, useRef } from "react";
import { Context } from "../../App";
import User from "../../components/calculator/User";
import Default from "../../components/Header/Default";
import { useParams } from "react-router";
import { Generic } from "../../components/error/Generic";
import LoadingDefault from "../../components/Loading/LoadingDefault";
import {
  isOperations,
  isFormData,
  isTypeSurebet,
} from "../../utils/calculator/typeGuards";
import { getOperationByPartLink } from "../../api/calculator/calculatorServices";
import { AppProviderCalculatorUser } from "../../context/ContextCalculatorUser";

function BonusCalculatorContent() {
  const { id } = useParams();
  const [status, setStatus] = useState("Loading");
  const [dataOperation, setDataOperation] = useState([]);
  const [formData, setFormData] = useState({
    title: "",
    sub_title: "",
    part_link: "",
    time_expiration: new Date(),
  });
  const settingsCalculator = useRef({
    roundIsSelected: false,
    roundValue: 0,
    indexBookmakerSelected: -1,
  });
  const [typeSurebet, setTypeSurebet] = useState("");
  const [bonusValue, setBonusValue] = useState(0);
  const [bonusProportionValue, setBonusProportionValue] = useState(0);

  useEffect(() => {
    (async () => {
      const res = await getOperationByPartLink(id);
      if (res.ok) {
        const operationSaved = res.data;
        if (
          operationSaved.marketDetails &&
          operationSaved.marketOperations &&
          isFormData(operationSaved.marketDetails) &&
          isOperations(operationSaved.marketOperations) &&
          isTypeSurebet(operationSaved.marketDetails.type_surebet)
        ) {
          let dateStr = operationSaved.marketDetails.time_expiration;
          operationSaved.marketDetails.time_expiration = new Date(dateStr);
          setDataOperation(operationSaved.marketOperations);
          const {
            title,
            sub_title,
            part_link,
            time_expiration,
            round_is_selected,
            round_value,
            index_bookmaker_selected,
          } = operationSaved.marketDetails;
          settingsCalculator.current.roundIsSelected = round_is_selected;
          settingsCalculator.current.roundValue = round_value;
          settingsCalculator.current.indexBookmakerSelected =
            index_bookmaker_selected;
          setFormData({ title, sub_title, part_link, time_expiration });
          setTypeSurebet(operationSaved.marketDetails.type_surebet);
          setBonusValue(operationSaved.marketDetails.bonus_value);
          setBonusProportionValue(
            operationSaved.marketDetails.bonus_proportion_value,
          );
          setStatus("Valid Data");
        } else {
          setStatus("Invalid Data");
        }
      } else if (res.status !== void 0 && res.status === 0) {
        setStatus("No Internet");
      } else setStatus("Invalid Data");
    })();
  }, [id]);

  if (status === "Loading") {
    return (
      <>
        <Default />
        <LoadingDefault />
      </>
    );
  }

  if (status === "Data Not Found") {
    return (
      <>
        <Default />
        <Generic message={"Calculadora não encontrada."} />
      </>
    );
  }

  if (status === "Invalid Data") {
    return (
      <>
        <Default />
        <Generic message={"Dados da calculadora inválidos."} />
      </>
    );
  }

  if (status === "No Internet") {
    return (
      <>
        <Default />
        <Generic
          message={
            "Sem conexão. Por favor, verifique sua internet e tente novamente."
          }
        />
      </>
    );
  }

  return (
    <>
      <Default />
      <AppProviderCalculatorUser>
        <User
          dataOperation={dataOperation}
          setDataOperation={setDataOperation}
          formData={formData}
          typeSurebet={typeSurebet}
          settingsCalculator={settingsCalculator}
          bonusValue={bonusValue}
          bonusProportionValue={bonusProportionValue}
        />
      </AppProviderCalculatorUser>
    </>
  );
} //

export default function BonusCalculatorPage({
  statusMode,
  setStatusMode,
  userData,
}) {
  const [buttonSpreadsheet, setButtonSpreadsheet] = useState(false);

  useEffect(() => {
    try {
      setButtonSpreadsheet(
        userData.username === "admin" ||
          JSON.parse(userData.account_features).includes("planilha") === true,
      );
    } catch {
      console.log("");
    }
  }, [userData]);

  return (
    <Context.Provider value={{ statusMode, setStatusMode, buttonSpreadsheet }}>
      <BonusCalculatorContent />
    </Context.Provider>
  );
}
